(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > 100) { this.header.classList.add('scrolled-past-header'); }
      else { this.header.classList.remove('scrolled-past-header'); }
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["read-more-section"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
  $("#toggle").click(function() {
    var elem = $(this).text().trim();
    if (elem === "{{ section.settings.btn_text }}") {
      $(this).text("Read Less");
      $(".more-text").slideDown();
    } else {
      $(this).text("{{ section.settings.btn_text }}");
      $(".more-text").slideUp();
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
